import * as React		from 'react';
import { 
	useState, 
	useContext,
	useEffect, 
}						from 'react';
import { Col, Row, Form, Nav, Card, Button, ListGroup, Badge, Alert, Modal, Spinner, Tab, Tabs } from "react-bootstrap";
import * as yup			from 'yup';
import * as formik		from 'formik';
import atlasApi			from "../utils/atlasapi";
import schemas			from "../data/dataSchemas";
import JSZip			from 'jszip';
import fs				from 'file-saver';
import {Prohibit}		from "@phosphor-icons/react";
import globalContext	from "../utils/globalContext";

//
//{
//
//    "name":"Latesto O\u00dc",
//    "airtableId":"rec4iQSTveeQTJnJD",
//    "email":"rein.palipea@latesto.ee",
//    "phone":"+3725045647",
//    "address":", ",
//    "id":233,
//    "properties":[
//        {
//            "id":"13402:002:0400",
//            "status":"Ready to sign"
//        }
//    ],
//    "totalArea":6.44
//
//}



export interface diagProps {
	owner: object;
	onClose: (value: string) => void;
}

const { Formik } = formik;

const available = [
	'getPropertiesGeoJson',
	'getPropertiesCsv',
	'getLandownersCsv',
	'getBoundaryGeoJson',
	'getRoadsGeoJson',
	'getPowerLinesGeoJson',
	'getTurbinesGeoJson',
	'getScreenshot',
];
const extensions = {
	'getPropertiesGeoJson': 'json',
	'getPropertiesCsv': 'csv',
	'getLandownersCsv': 'csv',
	'getBoundaryGeoJson': 'json',
	'getRoadsGeoJson': 'json',
	'getPowerLinesGeoJson': 'json',
	'getTurbinesGeoJson': 'json',
	'getScreenshot': 'png',
	'getProjectShapefile' : 'shp',
	'getProjectDXF': 'dxf',
	'getProjectOWS': 'ows',
	'getProjectGeojson':'json',
	'getProjectCsv': 'csv',
	'getProjectExcel': 'xlsx',
	'getProjectGeopackage' : 'gpkg'
};

const reportOptions = [
	{ key: 'noise', label: 'Noise report' },
	{ key: 'shadow', label: 'Shadow report' },
	{ key: 'iaep', label: 'AEP report' },
	{ key: 'production', label: 'Production time series' },
];

function DialogDownloadScenario({ owner, setup, onClose }) {

	const context = useContext(globalContext);

	const [validated, setValidated] = useState(false);
	const [status, setStatus] = useState({sent:null, message:''});
	const [availableReports, setAvailableReports] = useState(false);

	//const ownerCast = schemas.owner.cast(owner);

	const updateStatus = (s) => {
		setStatus(s);
	};

	useEffect(()=>{
		getReports();
	},[setup.scenario]);
	const getReports = ()=>{ 
		
		if(!setup?.scenario?.projectid || !setup?.scenario?.projectid)
			return;
		
		atlasApi.getReportStatus(setup.scenario.projectid, setup.scenario.scenario_id)
		.then((res) => {
	
			setAvailableReports(res);
	
		}).catch((e)=>{
			console.log(e);
			
		});
		return;

	};
	const handleClose = (data) => {
		onClose(data);
		updateStatus({sent:null, message:''});
	};
	const handleOnShow = (e) => {
	};

	const handleSubmit = (data) => {

		//updateStatus({sent:false, success:false, message:'Saving...'});

		//const filesToDownload = data.layers.filter(value => available.includes(value));
		const filesToDownload = Array.isArray(data.format) ?  data.format : [data.format];

		const zip = new JSZip();

		var filePromises = [];

		filesToDownload.forEach((file)=>{
				filePromises.push(context.tc.draw[file](setup.scenario, data));
		});

		Promise.all(filePromises).then((results)=>{
			results.forEach((f,k)=>{

				if(filesToDownload[k] == "getScreenshot"){
					zip.file([context.tc.draw.filenamify(context.getters.project.name)+'.png', f, {base64:true}]);
				}
				else {
					if(data.binary){

						if(!f)
							updateStatus({sent:null, error:'Error: Not able to export data, try again.'});
						else {
							//API returnes files already zipped
							fs.saveAs(f, context.tc.draw.filenamify(context.getters.project.name)+'.zip');
							updateStatus({sent:null, error:null});
							handleClose(filesToDownload);
						}

					}
					else {
						if(!results[k])
							updateStatus({sent:null, error:'Error: Not able to export data, try again.'});
						else {
							zip.file(...results[k]);
						}
					}
				}
			});


			if(!data.binary ){

				if(!Object.keys(zip.files).length)
					return;
				updateStatus({sent:null, error:null});
				zip.generateAsync({ type: 'blob' }).then(function (content) {
					fs.saveAs(content, context.tc.draw.filenamify(context.getters.project.name)+'.zip');
				});

				handleClose(filesToDownload);
			}



		});

	};


	return (
			<Modal size="md" show={setup.open} onHide={(e)=>handleClose(e)} dialogClassName={(setup.stack ? 'stack' : '')} backdropClassName={(setup.stack ? 'stack' : '')} onShow={(e)=>handleOnShow(e)} centered>
				<Modal.Header closeButton>
					<Modal.Title>Export data</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Row className="px-3 download">
																
										
										
    <Tabs defaultActiveKey="project" id="uncontrolled-tab-example" className="mb-3">
		<Tab key={1} eventKey="project" title="Project data">
			
			
			<Formik onSubmit={(d)=>{handleSubmit(d);}} initialValues={{binary: true, format: 'getProjectShapefile', properties: [], selectAll: false}}>
				{({ handleSubmit, handleChange, touched, values, errors, setFieldValue }) => {
					const layerOptions = [
						{ key: 'turbines', label: 'Turbines' },
						{ key: 'boundary', label: 'Boundary' },
						{ key: 'roads', label: 'Roads' },
						{ key: 'powerlines', label: 'Powerlines' },
						{ key: 'sensors', label: 'Sensors' },
					];
					return (
					<Form noValidate onSubmit={handleSubmit}>
						{status.sent === null ? (
							<>
								<div className="my-3 text-muted">
									All project data including turbines, boundary, roads, powerlines and sensors.
									
									CSV and Excel will only include the turbines.
								</div>

								<div className="d-flex justify-content-between align-items-center">
									<Form.Check
										type="checkbox"
										id="select-all-properties"
										label="Select all properties"
										className="fw-bold"
										checked={values.selectAll}
										onChange={(e) => {
											const checked = e.target.checked;
											setFieldValue("selectAll", checked);
											setFieldValue("properties", checked ? layerOptions.map((l) => l.key) : []);
										}}
									/>
									<span className="text-muted small">All will be included</span>
								</div>

								<hr />

								<div className="ps-4">
									{layerOptions.map((l) => (
										<Form.Check
											key={l.key}
											type="checkbox"
											id={"layer-" + l.key}
											label={l.label}
											className="mb-3"
											checked={values.properties.includes(l.key)}
											onChange={(e) => {
												const checked = e.target.checked;
												var newLayers = values.properties.filter((v) => v !== l.key);
												if (checked) newLayers.push(l.key);
												setFieldValue("properties", newLayers);
												setFieldValue("selectAll", newLayers.length === layerOptions.length);
											}}
										/>
									))}
								</div>

								<Form.Label className="mt-2">Format<span className="text-danger">*</span></Form.Label>
								<br />
								<Form.Select className="branded-select aw" onChange={(e) => setFieldValue("format", e.target.value)}>
									<option value="getProjectShapefile">Shapefile</option>
									<option value="getProjectDXF">DXF</option>
									<option value="getProjectOWS">OWS</option>
									<option value="getProjectGeojson">GeoJSON</option>
									<option value="getProjectCSV">CSV</option>
									<option value="getProjectExcel">Excel</option>
									<option value="getProjectGeopackage">Geopackage</option>
								</Form.Select>
								{!!status.error && 
								<div className="my-3">
									<Alert variant="danger" className="p-2 border-0 text-black"><Prohibit size={16} color="red" /> {status.error}</Alert>
								</div>
								}
								<div className="ps-4 d-flex">
									<Button variant="outline-primary" type="submit" className="ms-auto me-3" onClick={(e)=>handleClose(e)}>Cancel</Button>
									<Button variant="primary" type="submit" className="ms-3">Export</Button>
								</div>
								

							</>

							):(
								<Row className="mb-3 dialog-feedback">
									<Col xs="12" className="dialog-feedback-icon text-center">
										{
										status.sent ?
											(status.success ? 
												(<i className="ri-checkbox-circle-line text-success"></i>)
												:
												(<i className="ri-error-warning-line text-warning"></i>)
											)
											:
											(<Spinner animation="border" variant="info" className="mt-5" />)
										}
									</Col>
									<Col xs="12" className="dialog-feedback-text mb-5">
										{status.message}
									</Col>
								</Row>
							)
						}
					</Form>
				);
			}}
			</Formik>
			
		</Tab>
		<Tab key={2} eventKey="property" title="Property data">
			<Formik onSubmit={(d)=>{handleSubmit(d);}} initialValues={{binary: false,format: 'getPropertiesGeoJson',}}>	
				{({ handleSubmit, handleChange, touched, values, errors, setFieldValue }) => (
					<Form noValidate onSubmit={handleSubmit}>
						{status.sent === null ? (
							<>
								<div className="my-4">All properties currently shown on the map</div>
								
								
								<div className="d-flex justify-content-between align-items-center pt-4">
									<Form.Check
										type="checkbox"
										id="select-all-properties"
										label="Select all properties"
										className="fw-bold"
										checked={values.selectAll}
										onChange={(e) => {
											const checked = e.target.checked;
											setFieldValue("selectAll", checked);
										}}
									/>
									<span className="text-muted small">All will be included</span>
								</div>

								<hr className="mb-4" />
								
								Format:<br/>
								<Form.Select className="branded-select aw" onChange={(e) => setFieldValue("format", e.target.value)}>
									<option value="getPropertiesGeoJson">GeoJSON</option>
									<option value="getPropertiesCsv">CSV</option>
								</Form.Select>

								{!!status.error && 
								<div className="my-3">
									<Alert variant="danger" className="p-2 border-0 text-black"><Prohibit size={16} color="red" /> {status.error}</Alert>
								</div>
								}
								<div className="ps-4 d-flex">
									<Button variant="outline-primary" type="submit" className="ms-auto me-3" onClick={(e)=>handleClose(e)}>Cancel</Button>
									<Button variant="primary" type="submit" className="ms-3">Export</Button>
								</div>
								

							</>

							):(
								<Row className="mb-3 dialog-feedback">
									<Col xs="12" className="dialog-feedback-icon text-center">
										{
										status.sent ?
											(status.success ? 
												(<i className="ri-checkbox-circle-line text-success"></i>)
												:
												(<i className="ri-error-warning-line text-warning"></i>)
											)
											:
											(<Spinner animation="border" variant="info" className="mt-5" />)
										}
									</Col>
									<Col xs="12" className="dialog-feedback-text mb-5">
										{status.message}
									</Col>
								</Row>
							)
						}
					</Form>
				)}	
			</Formik>
		</Tab>
		<Tab key={3} eventKey="owners" title="Landowners">
			<Formik onSubmit={(d)=>{handleSubmit(d);}} initialValues={{binary: false,format: 'getLandownersCsv',}}>	
				{({ handleSubmit, handleChange, touched, values, errors, setFieldValue }) => (
					<Form noValidate onSubmit={handleSubmit}>
						{status.sent === null ? (
							<>
								<div className="my-4">All landowners currently in map in CSV format</div>
								
								
								
								<div className="d-flex justify-content-between align-items-center pt-4">
									<Form.Check
										type="checkbox"
										id="select-all-properties"
										label="Select all landowners"
										className="fw-bold"
										checked={values.selectAll}
										onChange={(e) => {
											const checked = e.target.checked;
											setFieldValue("selectAll", checked);
										}}
									/>
									<span className="text-muted small">All will be included</span>
								</div>

								<hr className="mb-4" />
								
								Format:<br/>
								<Form.Select className="branded-select aw" onChange={(e) => setFieldValue("format", e.target.value)}>
									<option value="getLandownersCsv">CSV</option>
								</Form.Select>


								{!!status.error && 
								<div className="my-3">
									<Alert variant="danger" className="p-2 border-0 text-black"><Prohibit size={16} color="red" /> {status.error}</Alert>
								</div>
								}
								<div className="ps-4 d-flex">
									<Button variant="outline-primary" type="submit" className="ms-auto me-3" onClick={(e)=>handleClose(e)}>Cancel</Button>
									<Button variant="primary" type="submit" className="ms-3">Export</Button>
								</div>
								

							</>

							):(
								<Row className="mb-3 dialog-feedback">
									<Col xs="12" className="dialog-feedback-icon text-center">
										{
										status.sent ?
											(status.success ? 
												(<i className="ri-checkbox-circle-line text-success"></i>)
												:
												(<i className="ri-error-warning-line text-warning"></i>)
											)
											:
											(<Spinner animation="border" variant="info" className="mt-5" />)
										}
									</Col>
									<Col xs="12" className="dialog-feedback-text mb-5">
										{status.message}
									</Col>
								</Row>
							)
						}
					</Form>
				)}	
			</Formik>
		</Tab>
		<Tab key={4} eventKey="reports" title="Reports">
			<Formik onSubmit={(d)=>{handleSubmit(d);}} initialValues={{binary: true,format: 'getProjectReport',properties:[]}}>	
				{({ handleSubmit, handleChange, touched, values, errors, setFieldValue }) => (
					<Form noValidate onSubmit={handleSubmit}>
						
							<>
		
								<div className="my-3 text-muted">
									Full detailed reports for the project. Select which reports to include. Reports can only be downloaded as PDF.
								</div>

								<div className="d-flex justify-content-between align-items-center">
									<Form.Check
										type="checkbox"
										id="select-all-properties"
										label="Select all reports"
										className="fw-bold"
										checked={values.selectAll}
										onChange={(e) => {
											const checked = e.target.checked;
											setFieldValue("selectAll", checked);
											setFieldValue("properties", checked ? reportOptions.map((l) => l.key).filter((v)=>availableReports[v]) : []);
										}}
									/>
									<span className="text-muted small">All will be included</span>
								</div>

								<hr />

								<div className="ps-4">
									{reportOptions.map((l) => (
										<Form.Check
											key={l.key}
											type="checkbox"
											id={"layer-" + l.key}
											label={l.label}
											className="mb-3"
											checked={values.properties.includes(l.key)}
											disabled={!availableReports[l.key]}
											onChange={(e) => {
												if(!availableReports[l.key])
													return;
												const checked = e.target.checked;
												var newLayers = values.properties.filter((v) => v !== l.key);
												if (checked) 
													newLayers.push(l.key);
												setFieldValue("properties", newLayers);
												setFieldValue("selectAll", newLayers.length === reportOptions.length);
											}}
										/>
									))}
								</div>


								{!!status.error && 
								<div className="my-3">
									<Alert variant="danger" className="p-2 border-0 text-black"><Prohibit size={16} color="red" /> {status.error}</Alert>
								</div>
								}
								<div className="ps-4 d-flex">
									<Button variant="outline-primary" type="submit" className="ms-auto me-3" onClick={(e)=>handleClose(e)}>Cancel</Button>
									<Button variant="primary" type="submit" className="ms-3" disabled={!values.properties.length}>Export</Button>
								</div>
							</>
						
					</Form>
				)}	
			</Formik>
		</Tab>
	</Tabs>
										




					</Row>
				</Modal.Body>
			</Modal>
	);
}

export default DialogDownloadScenario;